import React from 'react'
import { Chip } from '@material-ui/core'
import clsx from 'clsx'

import useStyles from './styles'
import constants from 'constants/index'

const ChipStatus = ({ status }) => {
  const classes = useStyles()
  const { SUGGESTED_STATUS, DISAPPROVED_STATUS, STATUSES_LABEL } =
    constants.supplierSuggestion

  return (
    <Chip
      className={clsx(classes.root, {
        [classes.suggested]: status === SUGGESTED_STATUS,
        [classes.disapproved]: status === DISAPPROVED_STATUS,
      })}
      label={STATUSES_LABEL[status]}
      size="small"
    />
  )
}

export default ChipStatus
